// extracted by mini-css-extract-plugin
module.exports = {"contents":"Hm-z","sectionHeading":"Im-z"};